import React from "react";
import { ITopicWithStats } from "../../app/types";
import { Button, Container, Divider, Progress, Table } from "semantic-ui-react";
import { getTopics } from "../../app/api";
import { Link } from "react-router-dom";

const MainPage = () => {
  const [topics, setTopics] = React.useState<ITopicWithStats[]>([]);
  React.useEffect(() => {
    getTopics().then((topics) => setTopics(topics));
  }, []);

  return (
    <Container style={{ paddingTop: 20, paddingBottom: 50 }}>
      <Link to={"/training/worst/"}>
        <Button size="huge" color="twitter">
          Решать косячные
        </Button>
      </Link>

      <h1>Темы:</h1>

      <Table>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Тема</Table.HeaderCell>
            <Table.HeaderCell>Вопросов</Table.HeaderCell>
            <Table.HeaderCell>Пройдено</Table.HeaderCell>
            <Table.HeaderCell>Успех</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        {topics.map((topic) => (
          <Table.Row key={topic.id}>
            <Table.Cell>
              <Link to={`/topic/${topic.id}/`}>
                <b>
                  {topic.id}. {topic.title}
                </b>
              </Link>
            </Table.Cell>
            <Table.Cell>{topic.total_questions}</Table.Cell>
            <Table.Cell>
              {/* @ts-ignore */}
              <Progress
                total={topic.total_questions}
                value={topic.answered_at_least_once}
                autoSuccess={true}
                size={"small"}
              >
                {topic.answered_at_least_once} из {topic.total_questions}
              </Progress>
            </Table.Cell>
            <Table.Cell>{Math.floor(topic.average_ratio * 100)}%</Table.Cell>
          </Table.Row>
        ))}
      </Table>
    </Container>
  );
};

export default MainPage;
